export default __webpack_public_path__ + "static/media/curve.18a1598e.svg";